import { Box, Button } from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDowngradeToStarterAPI } from "@arelia-components/SubscriptionDetails/useSubscriptionDetailsAPI";
import { useState } from "react";
import { Subscription } from "@arelia-types/subscriptions";
import { toast } from "sonner";

type Props = {
  subscription: Subscription;
};

export default function SubscriptionInfoActionsUser({ subscription }: Props) {
  const [isDowngrading, setIsDowngrading] = useState(false);
  const { mutateAsync: downgradeToStarter } = useDowngradeToStarterAPI();

  const handleDowngradeToStarter = async () => {
    setIsDowngrading(true);
    try {
      await downgradeToStarter();
      toast.success("Successfully downgraded to Starter Plan");
      window.location.reload();
    } catch {
      toast.error("Failed to downgrade to Starter Plan");
      setIsDowngrading(false);
    }
  };

  const showDowngradeButton = subscription.active === false;

  return (
    <Box sx={styles.actions}>
      {showDowngradeButton && (
        <Button
          variant="contained"
          color="warning"
          disabled={isDowngrading}
          onClick={handleDowngradeToStarter}
          startIcon={<ArrowDownwardIcon />}
        >
          Downgrade to Starter Plan
        </Button>
      )}
    </Box>
  );
}

const styles = {
  actions: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "center",
    gap: "16px",
    width: "100%"
  }
};
